import { apiClient } from './client'
import { ApiError } from './errors'

export async function redeemVoucher(code: string): Promise<{ id: number }> {
  try {
    // BE VoucherRedeemIn expects { redemption_code }, not { code }. Response is
    // the full voucher object; the caller only needs { id }.
    const response = await apiClient.post<{ id: number }>('vouchers/redeem', {
      redemption_code: code
    })
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}

export async function fetchVoucherStatus(
  code: string
): Promise<{ valid: boolean; status?: string; amount?: number }> {
  try {
    // BE VoucherStatusOut: { code, status, amount, expires_at } (amount is a
    // string). There is no `valid` flag — derive it from `status`.
    const response = await apiClient.get<{
      code: string
      status: string
      amount?: string | null
      expires_at?: string | null
    }>('vouchers/status', { params: { code } })
    const data = response.data
    return {
      valid: (data?.status ?? '').toLowerCase() === 'active',
      status: data?.status,
      amount: data?.amount != null ? Number(data.amount) : undefined
    }
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}

export async function buyVoucher(data: {
  amount: number
  from_name: string
  from_email: string
  to_name?: string
  to_email?: string
  note?: string
}): Promise<{ success: boolean; message: string }> {
  try {
    const response = await apiClient.post<{
      success: boolean
      message: string
    }>('vouchers/buy', data)
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}
